import styled from "styled-components";
import { useAppSelector } from "../../../../../../redux";
import { PostVideoProps } from "../../../../../../redux/slices/postVideo/postVideo";
import { VideoPlayer } from "../../../../../Common";
import { usePostCardContext } from "../PostCardContent";

export const VideoContent = () => {
  const { postId } = usePostCardContext();
  const { processed_posts } = useAppSelector((state) => state.newsfeed);

  const post = processed_posts[postId];
  if (!post) return null;
  const videos = post.media.video;
  if (!videos || videos.length === 0) return null;

  const videosComponents = videos.map((video) => (
    <Video key={video.id} {...video} />
  ));
  return <>{videosComponents}</>;
};

const Video = (props: PostVideoProps.VideoMediaResponse) => {
  const { isOnExpandedPostView } = usePostCardContext();
  const { id, title, description, duration, video_path } = props;
  if (!video_path || !id) return null;

  return (
    <PaddingContainer $isOnExpandedPostView={isOnExpandedPostView}>
      <VideoPlayer
        video_id={id}
        video_title={title}
        video_description={description}
        duration={duration}
        isViewOnly={false}
      />
    </PaddingContainer>
  );
};

const PaddingContainer = styled.div<{ $isOnExpandedPostView: boolean }>(
  ({ $isOnExpandedPostView, theme }) => `
  padding: ${$isOnExpandedPostView && theme.spacing["spacing-2"].value}rem
    ${$isOnExpandedPostView && theme.spacing["spacing-4"].value}rem;
`
);
